export default "__VITE_ASSET__Ds50mgmi__"